$(function () {
    /** ALL CLICKS **/

    $('body').on('click', '.toggle', function (e) {
        e.preventDefault();

        var $this = $(this);

        if ($this.next().hasClass('show-block')) {
            $this.next().removeClass('show-block');
            $this.removeClass('open');
            $this.next().slideUp(350);
        } else {
            $this.parent().parent().find('li .inner').removeClass('show-block');
            $this.parent().parent().find('li .toggle ').removeClass('open');
            $this.parent().parent().find('li .inner').slideUp(350);
            $this.next().toggleClass('show-block');
            $this.toggleClass('open');
            $this.next().slideToggle(350);
        }
    });

    $('body').on('click', '.burger_menulink', function (e) {
        e.preventDefault();
        if ($('html').hasClass('open_menu')) {
            $('html').removeClass('open_menu');
        } else {
            $('html').addClass('open_menu');
        }
    });
    $('body').on('click', '.burger_menu_m', function (e) {
        e.preventDefault();
        $('html').removeClass('open_menu');
    });

     $('body').on('click', '.show_more_less', function (e) {
        e.preventDefault();
        $(this).prev('.metafield-rich_text_field').toggleClass('active');
         if ($(this).text() == "Show more"){
           $(this).text("Show less")
         }else{
           $(this).text("Show more")
         }
    });

  $('body').on('click', '.arr_link', function (e) {
        e.preventDefault();
      $(this).next('.sub_menu').slideToggle();
  });
  

    /** ONE TIME INIT **/
    root.setup(1);

    $(window).resize(function () {
        root.setup(0);
    });

    $(window).scroll(root.scrollEvent);
});

$(window).on('load', function () {
    root.scrollEvent();
});

//Page functions
var root = {
    _width: 0,
    _height: 0,
    _header_height: 0,
    setup: function (init) {
        this._width = $(window).width();
        this._height = $(window).height();

        if (init === 1) {
            //Code that should be executed only once goes here
            //Add target blank for external links
            $("a[href^=http]").each(function () {
                if (this.href.indexOf(location.hostname) === -1)
                    $(this).attr('target', "_blank");
            });
            root.desktopMenu();
            root.pSlider();
            root.imgSlider();
            root.desktopsubMenu();
        }
        //Code that should execute on window resize goes here
    },
    scrollEvent: function (init) {
        requestAnimationFrame(function () {
            //Add layer behind sticky menu
            var st = $(window).scrollTop();
            if (st >= 200) {
                $('html').addClass('has-scrolled');
            } else {
                $('html').removeClass('has-scrolled');
            }
        });
    },
    pSlider: function () {
      var swiper = new Swiper(".pSwiper", {
        slidesPerView: 3.5,
        spaceBetween: 75,
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        // },
        breakpoints: {
          300: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          741: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1025: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
          1200: {
            slidesPerView: 3.5,
            spaceBetween: 75,
          },
        },
      });
    },
    desktopsubMenu: function () {
      $('.menu-wrap .sub_menu').each(function(){
          if($(this).find('li').length == 0) {
            $(this).prev('.arr_link').remove();
            $(this).remove();
          }
      });
    },
    desktopMenu: function () {
        var menu_div = $('<div/>').attr('class', 'mobile-menu');
        var burger_close = $('<div/>').attr('class', 'burger_menu_m');
        var burger_close_btn = $('<span/>').attr('class', 'burger_lines');
        var left_menuwrp_clone = $('.left-menuwrp').clone();
        var right_menuwrp_clone = $('.right-menuwrp').clone();
        menu_div.appendTo('body');
        burger_close.appendTo('.mobile-menu');
        burger_close_btn.appendTo('.burger_menu_m');
        left_menuwrp_clone.appendTo('.mobile-menu');
        right_menuwrp_clone.appendTo('.mobile-menu');
    },
  imgSlider: function(){
    var swiper = new Swiper(".imgSwiper", {
        slidesPerView: 3,
        spaceBetween: 0,
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        // },      
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      speed: 2500,
        breakpoints: {
          300: {
            slidesPerView: 1,
          },
          741: {
            slidesPerView: 2,
          },
          1025: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 3,
          },
        },
      });
  }
};